import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import AuthService from '../../services/AuthService'

class Logout extends Component {

  logoutUser() {
    AuthService.logout()
  }

  render() {
    return (
      <span onClick={this.logoutUser}>Logout</span>
    )
  }
}

export default Logout



// WEBPACK FOOTER //
// ./src/components/Logout/Logout.js